var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Typography from "@mui/material/Typography";
import { Accordion, AccordionDetails, AccordionSummary, Box, IconButton, Menu, MenuItem, Stack } from "@mui/material";
import Alert from "@mui/material/Alert";
import * as React from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Button from "@mui/material/Button";
import { useQuery } from "react-query";
import { RateCalculationService } from "../services/rate/rateCalculation.service";
import { addMonths, addYears, endOfDay, formatFullDate, formatFullDateTime, startOfDay } from "../utils/date.util";
import { RateService } from "../services/rate/rate.service";
import AddIcon from "@mui/icons-material/Add";
import { getAmountFormatted } from "../utils/currency.util";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import NewRateDialog from "./NewRateDialog";
import PickRateDialog from "./PickRateDialog";
import SearchIcon from '@mui/icons-material/Search';
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useReadOnly } from "../utils/hooks/users/useReadOnly";
var rateKey = function (rate) { var _a; return (_a = rate.id) !== null && _a !== void 0 ? _a : rate.parentRateId; };
var RatePreview = function (props) {
    var _a, _b;
    var t = useTranslation().t;
    var readOnly = useReadOnly();
    var _c = React.useState(false), displayingAll = _c[0], setDisplayingAll = _c[1];
    var _d = React.useState(false), newRateOpen = _d[0], setNewRateOpen = _d[1];
    var _e = React.useState(false), existingRateOpen = _e[0], setExistingRateOpen = _e[1];
    var _f = React.useState(null), anchorEl = _f[0], setAnchorEl = _f[1];
    var _g = React.useState(), menuRateId = _g[0], setMenuRateId = _g[1];
    var menuOpen = Boolean(anchorEl);
    var from = startOfDay(new Date());
    var to = endOfDay(addMonths(new Date(), 1));
    var ratesQ = useQuery(["rate", props.rateIds, from, to], function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            if (!((_a = props.rateIds) === null || _a === void 0 ? void 0 : _a.length))
                return [2 /*return*/, []];
            return [2 /*return*/, RateCalculationService.calculate({
                    ids: props.rateIds,
                    range: {
                        start: from,
                        end: to
                    }
                })];
        });
    }); });
    // The table above only covers the next month, so a rate starting later (e.g. next season's
    // price) used to leave the tab saying "no rates set" although the rate is attached and the
    // booking engine (12-month horizon) already sells it. List those rates separately instead.
    var ratesInWindowIds = new Set(((_a = ratesQ.data) !== null && _a !== void 0 ? _a : []).map(rateKey));
    var ratesOutsideWindowIds = ratesQ.isSuccess
        ? ((_b = props.rateIds) !== null && _b !== void 0 ? _b : []).filter(function (id) { return !ratesInWindowIds.has(id); })
        : [];
    var ratesOutsideWindowQ = useQuery(["rate-outside-window", ratesOutsideWindowIds, from], function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, attached, nextYear, attachedById;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, Promise.all([
                        // Archived (deleted) rates are excluded by the list endpoint, so they stay hidden
                        RateService.getAllRates({
                            id: ratesOutsideWindowIds,
                            limit: { offset: 0, limit: ratesOutsideWindowIds.length }
                        }),
                        RateCalculationService.calculate({
                            ids: ratesOutsideWindowIds,
                            range: {
                                start: from,
                                end: endOfDay(addYears(new Date(), 1))
                            }
                        })
                    ])];
                case 1:
                    _a = _c.sent(), attached = _a[0], nextYear = _a[1];
                    attachedById = new Map(((_b = attached.content) !== null && _b !== void 0 ? _b : []).map(function (rate) { return [rate.id, rate]; }));
                    return [2 /*return*/, ratesOutsideWindowIds.flatMap(function (id) {
                            var _a;
                            var rate = attachedById.get(id);
                            if (!rate)
                                return [];
                            var firstOccurrence = nextYear
                                .filter(function (r) { return rateKey(r) === id; })
                                .sort(function (a, b) { var _a, _b, _c, _d; return ((_b = (_a = a.startTime) === null || _a === void 0 ? void 0 : _a.getTime()) !== null && _b !== void 0 ? _b : 0) - ((_d = (_c = b.startTime) === null || _c === void 0 ? void 0 : _c.getTime()) !== null && _d !== void 0 ? _d : 0); })[0];
                            return [{
                                    // Calculated price carries the parent-rate chain and exclusive tax, like the booking engine
                                    rate: __assign(__assign({}, rate), { price: (_a = firstOccurrence === null || firstOccurrence === void 0 ? void 0 : firstOccurrence.price) !== null && _a !== void 0 ? _a : rate.price }),
                                    validFrom: firstOccurrence === null || firstOccurrence === void 0 ? void 0 : firstOccurrence.startTime
                                }];
                        })];
            }
        });
    }); }, { enabled: ratesOutsideWindowIds.length > 0 });
    useEffect(function () {
        setDisplayingAll(false);
    }, [props.entityId]);
    var handleCloseRateMenu = function () {
        setAnchorEl(null);
        setMenuRateId(undefined);
    };
    var renderRatesQ = function () {
        var _a, _b, _c, _d;
        if (ratesQ.isLoading) {
            return (_jsx(Typography, __assign({ variant: 'body1', color: 'text.secondary', textAlign: 'start' }, { children: t('Loading...') })));
        }
        if (ratesQ.isError) {
            return (_jsx(Typography, __assign({ variant: 'body1', color: 'text.secondary', textAlign: 'start' }, { children: t('We could not load rates') })));
        }
        var ratesOutsideWindow = (_a = ratesOutsideWindowQ.data) !== null && _a !== void 0 ? _a : [];
        if (!((_b = ratesQ.data) === null || _b === void 0 ? void 0 : _b.length) && ratesOutsideWindowQ.isLoading) {
            return (_jsx(Typography, __assign({ variant: 'body1', color: 'text.secondary', textAlign: 'start' }, { children: t('Loading...') })));
        }
        if (!((_c = ratesQ.data) === null || _c === void 0 ? void 0 : _c.length) && !ratesOutsideWindow.length) {
            return (_jsx(Box, __assign({ sx: {
                    border: '1px dashed',
                    borderColor: 'divider',
                    borderRadius: 1,
                    px: 2,
                    py: 3,
                    textAlign: 'center',
                } }, { children: _jsx(Typography, __assign({ variant: 'body1', color: 'text.secondary' }, { children: props.noRatesMessage })) })));
        }
        var ratesData = (_d = ratesQ.data) !== null && _d !== void 0 ? _d : [];
        // Group items by rate id
        var groupedItems = ratesData.reduce(function (acc, rate, index) {
            var _a;
            var rateId = (_a = rateKey(rate)) !== null && _a !== void 0 ? _a : "rate-".concat(index);
            if (!acc[rateId]) {
                acc[rateId] = [];
            }
            acc[rateId].push(rate);
            return acc;
        }, {});
        // Get unique IDs, limited by display setting
        var itemsByRateId = Object.keys(groupedItems);
        var itemsToDisplay = displayingAll ? itemsByRateId : itemsByRateId.slice(0, 10);
        var tableColumns = 'minmax(240px, 1fr) minmax(220px, 260px) 110px 128px';
        var getRateReferenceId = function (rate) { var _a; return (_a = rate.id) !== null && _a !== void 0 ? _a : rate.parentRateId; };
        var formatValidity = function (rate) { return ([formatFullDateTime(rate.startTime) || t('no start'), formatFullDateTime(rate.endTime) || t('no end')].join(' - ')); };
        var descriptionCellSx = {
            minWidth: 0,
        };
        var rightCellSx = {
            minWidth: 0,
            textAlign: 'right',
        };
        var renderViewRateButton = function (rate) { return (_jsx(Button, __assign({ endIcon: _jsx(OpenInNewIcon, {}), sx: { minWidth: 'fit-content' }, onClick: function () {
                var rateId = getRateReferenceId(rate);
                if (rateId) {
                    window.open("/system/rates/".concat(rateId), '_blank');
                }
            } }, { children: t('View') }))); };
        var renderMoreButton = function (rate, rowId) { return (_jsx(IconButton, __assign({ id: "more-menu-item-".concat(rowId), "aria-controls": menuOpen ? "basic-menu-item-".concat(rowId) : undefined, "aria-haspopup": "true", "aria-expanded": menuOpen ? 'true' : undefined, onClick: function (event) {
                event.stopPropagation();
                setAnchorEl(event.currentTarget);
                setMenuRateId(getRateReferenceId(rate));
            }, sx: {
                width: 36.5,
                height: 36.5,
                borderRadius: 1,
            } }, { children: _jsx(MoreVertIcon, {}) }))); };
        var renderRowActions = function (rate, rowId, showMenu) {
            if (showMenu === void 0) { showMenu = true; }
            return (_jsxs(Stack, __assign({ direction: 'row', alignItems: 'center', justifyContent: 'flex-end', gap: 1 }, { children: [renderViewRateButton(rate), showMenu && !props.disabled && !readOnly && !!props.onRemove && renderMoreButton(rate, rowId)] })));
        };
        var renderTableHeader = function () { return (_jsxs(Box, __assign({ sx: {
                display: 'grid',
                gridTemplateColumns: tableColumns,
                columnGap: 2,
                width: '100%',
                alignItems: 'center',
                pb: 1,
                borderBottom: '1px solid',
                borderColor: 'divider',
            } }, { children: [_jsx(Typography, __assign({ variant: 'body1', color: 'text.secondary', noWrap: true }, { children: t('Description') })), _jsx(Typography, __assign({ variant: 'body1', color: 'text.secondary', sx: rightCellSx, noWrap: true }, { children: t('Validity') })), _jsx(Typography, __assign({ variant: 'body1', color: 'text.secondary', sx: rightCellSx, noWrap: true }, { children: t('Price') })), _jsx(Typography, __assign({ variant: 'body1', color: 'text.secondary', sx: rightCellSx, noWrap: true }, { children: t('Actions') }))] }))); };
        var renderRateRow = function (rate, rowId, showDelete, note) {
            if (showDelete === void 0) { showDelete = true; }
            return (_jsxs(Box, __assign({ id: rowId, sx: {
                    display: 'grid',
                    gridTemplateColumns: tableColumns,
                    columnGap: 2,
                    width: '100%',
                    alignItems: 'center',
                    py: 1.5,
                    borderBottom: '1px solid',
                    borderColor: 'rgba(0, 0, 0, 0.08)',
                } }, { children: [_jsxs(Box, __assign({ sx: descriptionCellSx }, { children: [_jsx(Typography, __assign({ variant: 'body1', noWrap: true }, { children: rate.name || '-' })), note &&
                                _jsx(Typography, __assign({ variant: 'body2', color: 'text.secondary', noWrap: true }, { children: note }))] })), _jsx(Typography, __assign({ variant: 'body1', color: 'text.secondary', sx: rightCellSx, noWrap: true }, { children: formatValidity(rate) })), _jsx(Typography, __assign({ variant: 'body1', fontWeight: 600, sx: rightCellSx, noWrap: true }, { children: getAmountFormatted(rate.price, '-') })), renderRowActions(rate, rowId, showDelete)] }), rowId));
        };
        var renderRatesOutsideWindow = function () { return (_jsxs(Stack, __assign({ gap: 1 }, { children: [_jsx(Typography, __assign({ variant: 'subtitle1', textAlign: 'start' }, { children: t('Attached rates outside the next month') })), _jsx(Box, __assign({ sx: {
                        overflowX: 'auto',
                        width: '100%',
                    } }, { children: _jsxs(Stack, __assign({ sx: { minWidth: 760 } }, { children: [renderTableHeader(), ratesOutsideWindow.map(function (_a, index) {
                                var rate = _a.rate, validFrom = _a.validFrom;
                                return renderRateRow(rate, "rate-outside-window-".concat(index), true, validFrom
                                    ? t('Valid from {{date}}', { date: formatFullDate(validFrom) })
                                    : t('Not valid in the next 12 months'));
                            })] })) }))] }))); };
        if (!ratesData.length) {
            return (_jsxs(Stack, __assign({ gap: 2 }, { children: [_jsx(Alert, __assign({ severity: 'info', sx: { mb: 1 } }, { children: t('No rates/prices in the next month') })), renderRatesOutsideWindow()] })));
        }
        return (_jsxs(Stack, __assign({ gap: 2 }, { children: [_jsx(Alert, __assign({ severity: 'info', sx: { mb: 3 } }, { children: t('Rates/Prices in the next month') })), _jsx(Box, __assign({ sx: {
                        overflowX: 'auto',
                        width: '100%',
                    } }, { children: _jsxs(Stack, __assign({ sx: { minWidth: 760 } }, { children: [renderTableHeader(), itemsToDisplay.map(function (rateId, idIndex) {
                                var items = groupedItems[rateId];
                                // Use the first item for the group representation
                                var representativeRate = items[0];
                                var otherRates = items.slice(1);
                                if (items.length === 1) {
                                    return renderRateRow(representativeRate, "rate-".concat(idIndex));
                                }
                                return (_jsxs(Accordion, __assign({ disableGutters: true, elevation: 0, square: true, sx: {
                                        borderBottom: '1px solid',
                                        borderColor: 'rgba(0, 0, 0, 0.08)',
                                        '&:before': { display: 'none' },
                                        '&.Mui-expanded': { my: 0 },
                                    } }, { children: [_jsx(AccordionSummary, __assign({ expandIcon: _jsx(ArrowDownwardIcon, {}), "aria-controls": "rate-group-content-".concat(rateId), id: "rate-group-header-".concat(rateId), sx: {
                                                px: 0,
                                                minHeight: 'unset',
                                                '&.Mui-expanded': { minHeight: 'unset' },
                                                '& .MuiAccordionSummary-content': {
                                                    my: 0,
                                                    alignItems: 'center',
                                                },
                                            } }, { children: _jsxs(Box, __assign({ sx: {
                                                    display: 'grid',
                                                    gridTemplateColumns: tableColumns,
                                                    columnGap: 2,
                                                    width: '100%',
                                                    alignItems: 'center',
                                                    py: 1.5,
                                                } }, { children: [_jsxs(Typography, __assign({ variant: 'body1', sx: descriptionCellSx, noWrap: true }, { children: [representativeRate.name || '-', ' ', _jsxs(Box, __assign({ component: 'span', sx: { color: 'text.secondary' } }, { children: ["(", items.length, " ", t('entries'), ")"] }))] })), _jsx(Typography, __assign({ variant: 'body1', color: 'text.secondary', sx: rightCellSx, noWrap: true }, { children: formatValidity(representativeRate) })), _jsx(Typography, __assign({ variant: 'body1', fontWeight: 600, sx: rightCellSx, noWrap: true }, { children: getAmountFormatted(representativeRate.price, '-') })), renderRowActions(representativeRate, "rate-".concat(idIndex))] })) })), _jsx(AccordionDetails, __assign({ sx: { p: 0, pl: 3 } }, { children: otherRates.map(function (rate, rateIndex) { return (renderRateRow(rate, "rate-".concat(idIndex, "-item-").concat(rateIndex), false)); }) }))] }), rateId));
                            })] })) })), itemsByRateId.length > 10 && (_jsx(Button, __assign({ id: 'rate-expand-collapse', variant: 'text', onClick: function () { return setDisplayingAll(!displayingAll); }, size: 'small', sx: { alignSelf: 'flex-start', mb: 2 } }, { children: displayingAll ? t('Show less') : (t('Show all rate groups') + ' (' + itemsByRateId.length + ')') }))), ratesOutsideWindow.length > 0 && renderRatesOutsideWindow()] })));
    };
    return (_jsxs(Stack, { children: [!props.entityId ? (_jsx(Typography, __assign({ variant: 'body1', color: 'text.secondary', textAlign: 'start' }, { children: props.noEntityTitle }))) : (_jsxs(_Fragment, { children: [renderRatesQ(), !props.disabled &&
                        _jsxs(Stack, __assign({ direction: 'row', justifyContent: 'flex-end', gap: 2, mt: 2 }, { children: [_jsx(Button, __assign({ id: 'btn-plan-rate', variant: 'text', startIcon: _jsx(AddIcon, {}), onClick: function () {
                                        setNewRateOpen(true);
                                    } }, { children: t('Create new rate') })), _jsx(Button, __assign({ id: 'btn-plan-rate', variant: 'contained', startIcon: _jsx(SearchIcon, {}), onClick: function () {
                                        setExistingRateOpen(true);
                                    } }, { children: t('Attach existing rate') }))] }))] })), _jsx(NewRateDialog, { open: newRateOpen, onClose: function () { return setNewRateOpen(false); }, onConfirm: function (rate) {
                    var _a;
                    (_a = props.onAdd) === null || _a === void 0 ? void 0 : _a.call(props, rate);
                    setNewRateOpen(false);
                }, defaultName: props.defaultRateName }), _jsx(PickRateDialog, { open: existingRateOpen, onClose: function () { return setExistingRateOpen(false); }, onConfirm: function (rate) {
                    var _a;
                    (_a = props.onAdd) === null || _a === void 0 ? void 0 : _a.call(props, rate);
                    setExistingRateOpen(false);
                } }), _jsx(Menu, __assign({ id: 'basic-menu-item-rate', anchorEl: anchorEl, open: menuOpen, onClose: handleCloseRateMenu, MenuListProps: {
                    'aria-labelledby': 'basic-button',
                } }, { children: _jsx(MenuItem, __assign({ onClick: function () {
                        var _a;
                        menuRateId && ((_a = props.onRemove) === null || _a === void 0 ? void 0 : _a.call(props, menuRateId));
                        handleCloseRateMenu();
                    } }, { children: t('Delete') })) }))] }));
};
export default RatePreview;
